export const DefaultDateTimeFormatOptions: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "long",
  hour: "numeric",
  minute: "2-digit",
  hour12: true
};

/**
 * Formats a date string into a localized date and time string.
 * Localised according to the user's OS settings.
 *
 * @param date - The date string to format.
 * @returns The formatted date string or "-" for invalid input.
 */
export const formatDateTime = (date: string | undefined) => {
  if (!date) {
    return "-";
  }
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    return "-";
  }
  return new Intl.DateTimeFormat(undefined, DefaultDateTimeFormatOptions).format(parsedDate);
};
